import React, { useContext } from "react";
import styled from "styled-components";
import moment from "moment";
import Barcode from "react-barcode";

import { DatabaseContext } from "../../../contexts/DatabaseContext";
import { PatronContext } from "../../../contexts/PatronContext";
import { UserContext } from "../../../contexts/UserContext";
import { PaneContext } from "../../../contexts/PaneContext";

moment.locale("en-AU");

const SingleCard = () => {
  const { apiUrl } = useContext(DatabaseContext);
  const { previewPanePhoto } = useContext(PaneContext);
  const { Site } = useContext(UserContext);
  const { patron } = useContext(PatronContext);
  const {
    barcodePrefix,
    barcodeSuffix,
    barcodeEnabled,
    printedBarcode,
    printedID,
    logoEnabled,
    showPhoto,
    custom1,
    custom1Enabled,
    custom2,
    custom2Enabled,
    custom3,
    custom3Enabled,
  } = Site;
  return (
    <>
      <Container>
        <CardBackground
          orientation={Site.orientation}
          img
          src={`url(${apiUrl}/assets/cards/${Site.siteCode}.jpg)`}
        >
          <CardContent
            orientation={Site.orientation}
            backgroundimage={`url(${apiUrl}/assets/cards/${Site.siteCode}.jpg)`}
          >
            <LogoContainer>
              {logoEnabled && (
                <Logo
                  src={
                    `${apiUrl}/logos/${Site.siteCode}.png`
                      ? `${apiUrl}/logos/${Site.siteCode}.png`
                      : ""
                  }
                  onError={(event) => (event.target.style.display = "none")}
                />
              )}
            </LogoContainer>
            <Photo>
              {showPhoto && (
                <img
                  src={
                    previewPanePhoto
                      ? previewPanePhoto
                      : `${apiUrl}/defaults/patron.jpg`
                  }
                  alt={patron.externalID}
                  onError={(event) => (event.target.style.display = "none")}
                />
              )}
            </Photo>
            <Details>
              <PatronName>
                {patron.firstName} {patron.lastName}
              </PatronName>
              <PatronID>
                {printedID === "externalID"
                  ? patron.externalID
                  : printedID === "curriculum"
                  ? patron.curriculum
                  : printedID === "custom1"
                  ? patron.custom1
                  : printedID === "custom2"
                  ? patron.custom2
                  : printedID === "custom3"
                  ? patron.custom3
                  : ""}
              </PatronID>
              {custom1Enabled && (
                <ExtraDetail>
                  {custom1}: {patron.custom1}
                </ExtraDetail>
              )}
              {custom2Enabled && (
                <ExtraDetail>
                  {custom2}: {patron.custom2}
                </ExtraDetail>
              )}
              {custom3Enabled && (
                <ExtraDetail>
                  {custom3}: {patron.custom3}
                </ExtraDetail>
              )}
            </Details>

            <BarcodeContainer>
              {barcodeEnabled && (
                <Barcode
                  value={`${barcodePrefix}${
                    printedBarcode === "externalID"
                      ? patron.externalID
                      : printedBarcode === "curriculum"
                      ? patron.curriculum
                      : printedBarcode === "custom1"
                      ? patron.custom1
                      : printedBarcode === "custom2"
                      ? patron.custom2
                      : printedBarcode === "custom3"
                      ? patron.custom3
                      : patron.curriculum
                  }${barcodeSuffix}`}
                  format="CODE128"
                  background="none"
                  lineColor="#000"
                  height={20}
                  width={1}
                  marginLeft={1}
                  marginTop={1}
                  marginBottom={1}
                  marginRight={1}
                  fontSize={10}
                />
              )}
            </BarcodeContainer>
          </CardContent>
        </CardBackground>
      </Container>
    </>
  );
};

const Container = styled.div`
  padding: 1rem 0;
  width: 100%;
  margin: auto;
`;

const CardBackground = styled.div`
  position: relative;
  background: #ffffff;
  color: #000000;
  border-radius: 0.8rem;
  font-family: Arial, Helvetica, sans-serif;
  overflow: hidden;
  padding-top: ${(props) => (props.orientation === 0 ? "62%" : "145%")};
`;

const CardContent = styled.div`
  display: grid;
  grid-template-areas: ${(props) =>
    props.orientation === 0
      ? `'info info info'
  'photo details logo'
  'barcode barcode barcode'`
      : `
      'logo'
  'photo'
  'details'
  'barcode'`};
  grid-template-rows: ${(props) =>
    props.orientation === 0 ? `27% 53% 20%` : `14% 49% 25% 12%`};
  grid-template-columns: ${(props) =>
    props.orientation === 0 ? `21% 58% 21%` : `100%`};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: ${(props) => props.backgroundimage};
  background-size: cover;
  background-position: center;
`;

const LogoContainer = styled.div`
  grid-area: logo;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Logo = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

const Photo = styled.div`
  grid-area: photo;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    max-width: ${(props) => (props.orientation === 0 ? "100%" : "80%")};
    max-height: ${(props) => (props.orientation === 0 ? "80%" : "100%")};
  }
`;

const Details = styled.div`
  grid-area: details;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;

const PatronName = styled.div`
  font-size: calc(0.8rem + 0.4vw);
  font-weight: bold;
  margin-bottom: 0.5rem;
`;
const PatronID = styled.div`
  font-size: calc(1.2rem + 0.4vw);
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

const ExtraDetail = styled.div`
  font-size: calc(0.8rem + 0.4vw);
  margin-bottom: 0.5rem;
`;

const BarcodeContainer = styled.div`
  grid-area: barcode;
  display: flex;
  justify-content: center;
  padding-bottom: 0.5rem;
`;
export default SingleCard;
